<div class="page-container">
  <h2>Select Feed Destination</h2>

  <p>Select which feed you want to manage overrides for.</p>

  <div class="button-grid">
    <button
      *ngFor="let d of destinations"
      mat-raised-button
      color="primary"
      (click)="go(d.code)"
    >
      {{ d.name }}
    </button>
  </div>
</div>
